import { Injectable, EventEmitter, OnDestroy } from '@angular/core';
import { Subscription } from 'rxjs';
import { ArboService } from './arbo.service';
import { HttpService } from './http.service';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class AccountService implements OnDestroy {
  private type = 'Account';

  // Cache em memória com TTL
  private _listAllCache: { data: any[]; timestamp: number } | null = null;
  private CACHE_TTL = 5 * 60 * 1000; // 5 minutos

  // EventEmitter para notificar mudanças em contas (criar, atualizar, excluir)
  public accountsChanged = new EventEmitter<void>();

  private accountsChangedSub: Subscription;

  constructor(
    private arboService: ArboService,
    private httpService: HttpService
  ) {
    this.accountsChangedSub = this.accountsChanged.subscribe(() => this.invalidateCache());
  }

  ngOnDestroy(): void {
    this.accountsChangedSub?.unsubscribe();
  }

  async create(data) { 
    const result = await this.arboService.create(this.type, data);
    this.accountsChanged.emit(); // Notifica mudanças
    return result;
  }

  get(id) { return this.arboService.get(this.type+'/account',id); }

  list(page=1, qtd=10, sectionId=null) { return this.arboService.list(this.type, page, qtd, sectionId); }

  async update(data) { 
    const result = await this.arboService.update(this.type, data);
    this.accountsChanged.emit(); // Notifica mudanças
    return result;
  }

  async delete(id) {
    const result = await this.arboService.delete(this.type, id);
    this.accountsChanged.emit(); // Notifica mudanças
    return result;
  }

  getInsights(type,ids,variable,strat='id',agregateFunc=[''],startDate=null,endDate=new Date()){
    if(startDate === null){
      startDate = new Date(new Date().setDate(endDate.getDate() -7));
    }
    const startDateISO = startDate.toISOString();
    const endDateISO = endDate.toISOString();
    if(String(agregateFunc)===''){
      agregateFunc = ['max'];
    }
    return this.arboService
      .list(this.type+'/insights/'+type+'/'+ids+'/'+variable+'/'+strat+'/'+agregateFunc+'/'+startDateISO+'/'+endDateISO);
  }

  /**
   * Recupera o overview agregado do perfil para uma Account específica.
   * Endpoint: Account/aggregatedProfile-overview?accountId=<accountId>
   */
  aggregatedProfileOverview(accountId: string | number) {
    const path = `${this.type}/aggregatedProfile-overview?accountId=${accountId}`;
    return this.arboService.list(path);
  }

  /**
   * Lista todas as sections (organizações) filhas de uma section pai.
   * Endpoint: GET /Account/Section/:sectionId
   * @deprecated Use sectionService.listByParent() para listar organizações
   */
  listBySection(sectionId: string | number) {
    return this.httpService.get(`${environment.arboUrl}/${this.type}/Section/${sectionId}`);
  }

  /**
   * Lista todas as accounts
   * Endpoint: GET /Account/?offset=0&limit=100
   */
  listAll(offset: number = 0, limit: number = 100) {
    if (this._listAllCache && (Date.now() - this._listAllCache.timestamp < this.CACHE_TTL)) {
      return Promise.resolve(this._listAllCache.data);
    }
    return this.httpService.get(`${environment.arboUrl}/${this.type}/?offset=${offset}&limit=${limit}`)
      .then(data => {
        this._listAllCache = { data, timestamp: Date.now() };
        return data;
      });
  }

  invalidateCache() {
    this._listAllCache = null;
  }

}
